<template>
  <!-- 党内集中教育活动查看更多二级页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党史学习</el-breadcrumb-item>
          <el-breadcrumb-item>党内集中教育活动</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--内容-->
      <div class="dsxxpage-cont">
        <div class="dsxxpage-tit">党内集中教育活动</div>
        <el-tabs
          v-model="activeName"
          :tab-position="tabPosition"
          @tab-click="handleClick"
        >
          <el-tab-pane v-for="(item,i) in list" :key="item.id" :name="item.id.toString()">
            <span slot="label" v-if="i < 7 || i==list.length-2">
              <span :style='{display: item.columnName.split("年")[
                  item.columnName.split("年").length - 1
                ].includes("\\n") ? "inline" : "block"}'>{{
                item.columnName.replace(
                  item.columnName.split("年")[
                    item.columnName.split("年").length - 1
                  ],
                  ""
                )
              }}</span>
              <span :style='{display: item.columnName.split("年")[
                  item.columnName.split("年").length - 1
                ].includes("\\n") ? "inline" : "block"}' v-html='item.columnName.split("年")[
                  item.columnName.split("年").length - 1
                ].replace(/\\n/g,"<br/>")'></span>
            </span>
            <span slot="label" v-else>{{ item.columnName }}</span>
            <div class="dnhd-cont">
              <div class="dnhd-cont-up">
                <h2 v-html='item.columnName.replace(/\\n/g,"")'></h2>
                <p v-html="con[index]"></p>
              </div>
              <div class="dnhd-cont-down">
                <h5>文献研究</h5>
                <el-empty v-if="!loading && !dnhdList.length"></el-empty>
                <ul v-else v-loading="loading">
                  <li v-for="(item, index) in dnhdList" :key="index">
                    <a class="text-ellipsis" :title="item.title" :href="item.nodeUrl" target="_blank">{{ item.title }}</a>
                    <span>{{ item.pubDate.substr(0,10) }}</span>
                  </li>
                  <p>
                    <a
                      :href="`/#/more/${uidList[index]}/${breadcrumb}`" target="_blank"
                      v-if="total>10"
                      >查看更多>></a
                    >
                  </p>
                </ul>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tabPosition: "left",
      activeName: "",
      index:0,
      uidList: [],
      list: [],
      dnhdList: [],
      con: [
        '2025年3月12日，中央党的建设工作领导小组召开会议。会议指出，党中央决定，自2025年全国两会后至7月在全党开展深入贯彻中央八项规定精神学习教育。',
        '为深入学习贯彻修订后的《中国共产党纪律处分条例》，经党中央同意，自2024年4月至7月在全党开展党纪学习教育。这次党纪学习教育，是加强党的纪律建设、推动全面从严治党向纵深发展的重要举措。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目标要求：学纪、知纪、明纪、守纪。准确把握党纪学习教育的目标要求，教育引导党员干部学纪、知纪、明纪、守纪，搞清楚党的纪律规矩是什么，弄明白能干什么、不能干什么，始终做到忠诚干净担当。',
        '2023年4月1日，中共中央颁发了《关于在全党深入开展学习贯彻习近平新时代中国特色社会主义思想主题教育的意见》（以下简称《意见》）。《意见》指出，根据党的二十大部署，党中央决定，以县处级以上领导干部为重点在全党深入开展学习贯彻习近平新时代中国特色社会主义思想主题教育，用党的创新理论统一思想、统一意志、统一行动，弘扬伟大建党精神，牢记“三个务必”，推动全党为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。',
        "党史学习教育动员大会2021年2月20日上午在北京召开。中共中央总书记、国家主席、中央军委主席习近平出席会议并发表重要讲话。他强调，在全党开展党史学习教育，是党中央立足党的百年历史新起点、统筹中华民族伟大复兴战略全局和世界百年未有之大变局、为动员全党全国满怀信心投身全面建设社会主义现代化国家而作出的重大决策。全党同志要做到学史明理、学史增信、学史崇德、学史力行，学党史、悟思想、办实事、开新局，以昂扬姿态奋力开启全面建设社会主义现代化国家新征程，以优异成绩迎接建党一百周年。",
        "“不忘初心、牢记使命”主题教育是在全党范围内开展的主题教育活动，是推动全党更加自觉地为实现新时代党的历史使命不懈奋斗的重要内容。2017年10月18日，习近平总书记在十九大报告中指出，在全党开展“不忘初心、牢记使命”主题教育，用党的创新理论武装头脑，推动全党更加自觉地为实现新时代党的历史使命不懈奋斗。2019年5月13日， 中共中央政治局召开会议，决定从2019年6月开始，在全党自上而下分两批开展“不忘初心、牢记使命”主题教育。",
        "“两学一做”学习教育，即 “学党章党规、学系列讲话，做合格党员”学习教育。这是推动党内教育从“关键少数”向广大党员拓展、从集中性教育向经常性教育延伸的重要举措。这是落实党章关于加强党员教育管理要求、面向全体党员深化党内教育的重要实践，是加强党的思想政治建设的重要部署。对于进一步增强广大党员政治意识、大局意识、核心意识、看齐意识，坚定正确政治方向；进一步树立清风正气，严守政治纪律政治规矩；进一步强化宗旨观念，勇于担当作为，在生产、工作、学习和社会生活中起先锋模范作用，具有重要的意义。",
        "“三严三实”是指严以修身、严以用权、严以律己；谋事要实、创业要实、做人要实。这次专题教育作为党的群众路线教育实践活动的延展深化，把学习教育放在首位，组织专题党课、专题学习研讨、专题民主生活会和组织生活会，着力解决“不严不实”的突出问题，强化整改落实和立规执纪，以解决问题的成果检验专题教育的成效。“三严三实”的要求，为党员领导干部加强修养、改进作风、健康成长指明了方向。",
        "这次活动，以“为民、务实、清廉”为主要内容，以贯彻落实中央八项规定为切入点，以县处级以上领导机关、领导班子和领导干部为重点，突出作风建设，坚决反对形式主义、官僚主义、享乐主义和奢靡之风，教育引导党员干部牢固树立宗旨意识和马克思主义群众观点。这次活动达到了预期目的，取得重大成果：一是广大党员、干部贯彻群众路线的自觉性和坚定性明显增强；二是群众反映强烈的突出问题得到有效解决；三是探索了新形势下严肃党内政治生活的有效途径；四是制度执行力和约束力得到增强；五是党的执政基础更加稳固。",
        "这是深入学习实践科学发展观活动的继续。开展这次活动，是推动科学发展、促进社会和谐的需要，是加强基层党组织建设的需要，是进一步调动和激发广大党员积极性创造性的需要。活动的主要形式是，创建先进基层党组织、争做优秀共产党员。活动的主要做法是，紧紧围绕中心工作，服务科学发展大局；贴近基层单位实际，确定具体争创主题；坚持分类指导，设计活动载体；加强舆论宣传；广泛吸引群众参与。这次活动取得了显著成效，是新形势下保持发展党的先进性纯洁性的成功实践。",
        "这次活动紧紧围绕“党员干部受教育，科学发展上水平，人民群众得实惠”的总要求，以县级以上领导班子和党员领导干部为重点、全体党员参加，自上而下分三批进行。这次实践活动牢牢把握坚持解放思想、突出实践特色、贯彻群众路线、正面教育为主的原则，基本实现了提高思想认识、解决突出问题、创新体制机制、促进科学发展、加强基层组织的目标。",
        "这次活动，以“增强党员素质、加强基层组织、服务人民群众、促进各项工作”为目标，重点在于解决实际问题，特别是解决群众反映强烈的突出问题，以群众是否满意作为衡量标准。通过先进性教育活动，党员和党组织存在的突出问题得到解决，涉及改革发展稳定和群众切身利益的实际问题得到解决，取得了丰硕的实践成果、制度成果和理论成果；基层党组织的创造力、凝聚力、战斗力进一步增强；党群关系更加密切。",
        "讲学习，主要是学理论，学知识，学技术。讲政治，包括政治方向、政治立场、政治纪律、政治鉴别力、政治敏锐性。讲正气，就是要继承和发扬我们党在长期革命和建设事业中形成的好传统、好作风，坚持真理、坚持原则，坚持同一切歪风邪气和各种腐败现象作斗争。以整风精神进行的“三讲”教育，是切实解决领导干部队伍党性党风方面突出问题的一次实践。",
        "这次整党的任务是：统一思想，整顿作风，加强纪律，纯洁组织。整党的步骤是：从中央到基层组织，自上而下、分期分批地整顿。每个单位党组织的整顿，也要自上而下，先领导班子、领导干部，后党员群众。整党的基本方法是：在认真学习文件，提高思想认识的基础上，开展批评和自我批评，分清是非，纠正错误，纯洁组织。",
        "整风运动围绕着正确处理人民内部矛盾这一主题，采取开门整风的形式，听取党内外群众的意见，初期取得了较好的效果。整风运动中，群众提出的意见绝大部分是正确的、有益的，有利于改进党的领导。但是，由于对阶级斗争形势作了过分严重的估计，党内整风转为反右派斗争，党和国家的事业遭受了损失。",
        "1951年2月，党中央提出以三年的时间进行一次整党的任务，重点解决党内思想不纯和组织不纯等问题。1952年，随着“三反”运动的开展，党中央要求全党将整党工作与“三反”运动结合起来，查处了一批有贪污浪费行为和官僚主义现象的党员干部及少数腐化变质分子。",
        "这是新中国成立后党开展的第一次整风运动。整风的主要任务是，提高干部和一般党员的思想水平和政治水平，克服工作中所犯的错误，克服以功臣自居的骄傲自满情绪，克服官僚主义和命令主义，改善党和人民的关系。整风的重点是，整顿各级领导机关和干部。一般由首长负责，总结报告工作，阅读指定文件，讨论政策执行情况，检查思想和作风，开展批评和自我批评，然后制定改进办法和建立健全必要的工作制度。",
        "这主要是为了解决一些党组织特别是农村基层党组织中存在的思想、作风和组织不纯的问题。整党的基本方针是开展批评与自我批评，以说服教育为主，惩前毖后，治病救人。整党的基本方法是，公开党的支部，吸收非党群众参加党的支部大会，使三查三整工作接受群众的监督；对少数被地主、富农和流氓分子操纵的党支部，则由上级组织派出工作组重新组建党支部，并协助支部开展整党工作。通过整党，农村基层党组织在思想上、政治上和组织上都有很大进步，党同群众的联系更加密切。",
        "这是第一次全党范围内的马克思主义的思想教育运动，开创了党内集中教育活动的先河。整风运动的内容是反对主观主义以整顿学风、反对宗派主义以整顿党风、反对党八股以整顿文风。整风运动贯彻 “惩前毖后”和“治病救人”的方针，着重于提高思想认识，团结同志。整风运动的方法步骤是，认真阅读文件，联系个人思想和工作，自我反省，开展批评和自我批评，提高认识，总结经验，逐步取得思想认识的一致，增强党性，改进工作。整风运动是加强党的建设伟大工程的一个创造，对党的建设具有重大和深远的意义。"
      ],
      breadcrumb:'党史学习>党内集中教育活动',
      total:0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.axios
        .get(
          "data/custom/classType?uid=a4c0133f-e9de-4727-86a1-c2791947b154&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            this.list = res.data.rows;
            this.uidList = this.list.map((item) => item.uid);
            this.activeName = this.$route.params.id ? this.$route.params.id.toString() : this.list[0].id.toString()
            if(this.$route.params.id) {
              this.list.find((item,i) => {
                if(item.id==this.$route.params.id) this.index = i
              })
            }
            this.getData();
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    getData() {
      this.loading = true
      this.axios
        .post(`data/cnki/getKbaseList`, {
          uid: this.uidList[this.index],
          pageNum: 1,
          pageSize: 10,
        })
        .then((res) => {
          this.loading = false
          if (res.status == 200) {
            this.dnhdList = res.data.rows;
            this.total = res.data.total
            this.loading = false;
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    handleClick(val) {
      this.index = Number(val.index)
      this.getData();
    },
  },
};
</script>

<style  lang="scss" scoped>
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
    .dsxxpage-tit {
      position: absolute;
      z-index: 10;
      top: -2px;
      left: -8px;
      width: 298px;
      height: 51px;
      text-align: center;
      line-height: 51px;
      font-size: 18px;
      color: #f9fdcc;
      background: url("../assets/images/dnhd-titbg.png") no-repeat;
      background-size: 100% 100%;
    }
    :deep(.el-tabs--left .el-tabs__header.is-left) {
      padding: 50px 14px 0;
      height: auto;
      padding-bottom: 30px;
      background: #fff8f8;
      border: 1px solid #fae0e0;
    }
     :deep(.el-tabs__item) {
      text-align: center;
      display: flex;
      align-items: center;
      width: 253px;
      justify-content: center;
      line-height: normal;
      box-sizing: border-box;
      padding: 14px 14px;
      margin-top: 12px;
      letter-spacing: 1px;
      font-size: 14px;
      height: auto;
      letter-spacing: 1px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: break-spaces !important;

      // color: #383636;
      background: url("../assets/images/dnhd_navbg.png") repeat-y center;
      background-size: 100% 100%;
    }
     :deep(.el-tabs__item:hover) {
      color: #de1c26;
    }
     :deep(.el-tabs__item.is-active) {
      color: #fff;
      background: url("../assets/images/dnhd-active.png") no-repeat center;
      background-size: cover;
    }
     :deep(.el-tabs__active-bar) {
      display: none;
    }
     :deep(.el-tabs__nav-wrap.is-left::after) {
      height: 0;
    }
    //
    .dnhd-cont {
      width: 922px;
      height: auto;
      .dnhd-cont-up {
        // width: 912px;
        margin-left: 30px;
        box-sizing: border-box;
        padding: 35px 30px;
        background: url("../assets/images/dnhd-upbg.png") no-repeat;
        background-size: cover;
        h2 {
          font-size: 20px;
          font-weight: bold;
          color: #de1c26;
          text-align: center;
        }
        p {
          margin-top: 22px;
          font-size: 16px;
          line-height: 26px;
          text-indent: 30px;
          letter-spacing: 1px;
        }
        // dl{
        //     margin-left: 30px;
        //     dt{
        //         font-size: 20px;
        //         font-weight:bold;
        //         color: #DE1C26;
        //     }
        //     dd{
        //         margin-top:14px;
        //         font-size: 16px;
        //         line-height:25px;
        //         color: #000000;
        //         span{
        //             color: #DE1C26;
        //         }
        //     }
        // }
      }
      .dnhd-cont-down {
        min-height: 200px;
        margin-left: 30px;
        margin-top: 15px;
        box-sizing: border-box;
        padding: 16px 30px 0 30px;
        background: url("../assets/images/dnhd-dwbg.png") no-repeat;
        display: flex;
        flex-direction: column;
        h5 {
          font-size: 20px;
          font-weight: bold;
          color: #de1c26;
          margin-bottom: 5px;
        }
        ul {
          flex: 1;
          li {
            position: relative;
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            line-height: 40px;
            a {
              margin-left: 18px;
              max-width: 700px;
            }
            &:before {
              position: absolute;
              top: 14px;
              content: "";
              display: inline-block;
              width: 8px;
              height: 12px;
              background: url("../assets/images/vector.png") no-repeat;
            }
          }
        }
        p {
          text-align: right;
          font-size: 16px;
          margin-top: 10px;
          a {
            color: #9f9fa6;
          }
        }
      }
    }
  }
}
</style>